import { AuthContext, trelloStorageService } from "@harvestr-api/common";
import {
    gqlDiscovery,
    gqlTrelloCardCreateWithoutDiscoveryInput
} from "@harvestr-api/models";
import { trelloApiService } from "../services/trello-api.service";
import { trelloWebhookService } from "../services/trello-webhook.service";

export const trelloCardFacade = {
    async createCardAndRegisterWebhook(
        data: {
            harvestrCard: gqlTrelloCardCreateWithoutDiscoveryInput;
            discovery: Pick<gqlDiscovery, "id" | "title" | "clientId">;
            copyDiscoveryAttachments: boolean;
        },
        context: AuthContext
    ) {
        const fullHarvestrIssue = await trelloApiService.createCard(
            data,
            context
        );
        const webhookId = await trelloWebhookService.registerWebhookOnCard(
            fullHarvestrIssue,
            context
        );
        return {
            ...fullHarvestrIssue,
            trelloWebhookId: webhookId
        };
    },
    async linkCardAndRegisterWebhook(
        data: {
            harvestrCard: gqlTrelloCardCreateWithoutDiscoveryInput;
            discovery: Pick<gqlDiscovery, "id" | "title" | "clientId">;
            copyDiscoveryAttachments: boolean;
        },
        context: AuthContext
    ) {
        const fullHarvestrIssue = await trelloApiService.linkCard(
            data,
            context
        );
        const webhookId = await trelloWebhookService.registerWebhookOnCard(
            data.harvestrCard,
            context
        );
        return {
            ...fullHarvestrIssue,
            trelloWebhookId: webhookId
        };
    },
    async unregisterWebhookOfCard(
        data: {
            cardId: string;
        },
        context: AuthContext
    ) {
        const harvestrCard: gqlTrelloCardCreateWithoutDiscoveryInput = await trelloStorageService.getCardFromStorageById(
            data.cardId
        );

        await trelloWebhookService.unregisterWebhookOnCard(
            <string>harvestrCard.trelloWebhookId,
            harvestrCard.trelloId,
            context
        );
    }
};
